import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import pluralize from 'pluralize';

import useUniformConfigurationSelector from '../../../../../../hooks/useUniformConfigurationSelector';

const propTypes = {
  contactLabel: PropTypes.string,
  uniformConfiguration: PropTypes.shape({
    id: PropTypes.string,
    album_folder_tag_id: PropTypes.string,
    uniform_album_folder_tag_level_id: PropTypes.string,
    uniform_album_folder_tag_team_id: PropTypes.string,
    label: PropTypes.string,
  }),
  setUniformConfiguration: PropTypes.func,
};
const UniformConfigurationSelector = ({
  contactLabel,
  uniformConfiguration,
  setUniformConfiguration,
}) => {
  const { albumFolder, selectorOptions } = useUniformConfigurationSelector({});

  if (!albumFolder || selectorOptions.length === 0) {
    return null;
  }

  const contactLabelPlural = pluralize(contactLabel, 2);

  return (
    <div className="mt-1 mb-2">
      <h4 className="mb-0">Uniform Configuration</h4>
      <hr className="w-100 my-1" />
      <p>
        Select the tag, level, and team configuration to apply to this set of{' '}
        {contactLabelPlural}. This setup, along with the jersey numbers for each
        {contactLabel}, will be utilized to match any images of the{' '}
        {contactLabel} wearing the matching jersey, even when the faces are
        obscured!
      </p>
      <p>
        <b>Note:</b> You <b>must</b> provide a jersey number per {contactLabel}{' '}
        if using uniform configuration.
      </p>
      <div className="text-left">
        <Select
          id="uniform-tag-configuration"
          options={selectorOptions}
          placeholder="Search uniform configuration..."
          label="Select the tag, level, and team configuration"
          value={uniformConfiguration}
          getOptionValue={item => item.id}
          filterOption={(option, searchText) => {
            if (
              option.label
                .toLowerCase()
                .includes((searchText ?? '').toLowerCase())
            ) {
              return true;
            }
            return false;
          }}
          onChange={selectedOption => {
            if (selectedOption) {
              setUniformConfiguration(selectedOption);
            } else {
              setUniformConfiguration(undefined);
            }
          }}
          cacheOptions
          isClearable
        />
      </div>
    </div>
  );
};

UniformConfigurationSelector.propTypes = propTypes;

export default UniformConfigurationSelector;
